import React from "react";
import { useAuthState, useSignOut } from "react-firebase-hooks/auth";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Loading from "../Component/Shear/Loading/Loading";
import auth from "../FirebaseInit/FirebaseInit";
import { useQuery } from "react-query";

function RequireAdmin({ children }) {
  let location = useLocation();
  const [signOut] = useSignOut(auth);
  let navigate = useNavigate();

  const [user, PLoading] = useAuthState(auth);

  const { data, isLoading, refetch } = useQuery(["single-user", user], () =>
    fetch(`https://itghar-back.onrender.com/single-user?email=${user?.email}`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => {
      if (res.status === 401 || res.status === 403) {
        navigate("/");
        signOut(auth);
      }

      return res.json();
    })
  );

  if (isLoading || PLoading) {
    return <Loading />;
  }

  const admin = data?.role === "admin";

  if (!user || !admin) {
    signOut();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAdmin;
